module.exports = __webpack_public_path__ + "static/media/tipologia2.0ae139ce.png";